(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-v2"] && !Shopify.designMode) return;
  try {
    
/* =======================================================================
   0.  Small helper → give any Slick-slider a progress bar
   ======================================================================= */
function attachProgressBar ($slick){
  if (!$slick || !$slick.length) return;                /* safety */

  /* create (or re-use) the bar that lives right after the slider */
  let $progress = $slick.next('.z2-slick-progress'),
      $fill     = $progress.find('.z2-slick-progress__fill');

  if (!$progress.length){
    $progress = $(
      '<div class="z2-slick-progress">' +
        '<span class="z2-slick-progress__fill"></span>' +
      '</div>'
    );
    $slick.after($progress);
    $fill = $progress.find('.z2-slick-progress__fill');
  }

  /* ---------- resize + (un)hide ------------------------------------ */
  function paint (slick, idx){
    if (!slick) return;                                  /* guard */

    const vis   = slick.options.slidesToShow;            /* adapts */
    const total = slick.slideCount;                      /* real slides */

    /* hide bar when everything fits on one screen */
    if (total <= vis){
      $progress.hide();
      return;
    }
    $progress.show();

    const cur   = idx != null ? idx : slick.currentSlide;
    const shown = Math.min(cur + vis, total);            /* clamp */
    $fill.css('transform', 'scaleX(' + (shown / total) + ')');
  }

  /* ---------- wait until Slick has an API object ------------------- */
  (function waitForInstance (){
    const api = $slick[0] && $slick[0].slick;
    if (!api){
      return setTimeout(waitForInstance, 40);            /* poll again */
    }

    paint(api);                                          /* first paint */

    /* keep it synced */
    $slick
      .on('afterChange.recoBar',  (e,s,i)=>paint(s,i))
      .on('breakpoint.recoBar',   (e,s)  =>paint(s));
  })();
}

/* =======================================================================
   1.  <product-recommendations> custom element
   ======================================================================= */
class ProductRecommendations extends HTMLElement {
  constructor () {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(r => r.text())
        .then(htmlTxt => {
          /* inject fetched HTML ------------------------------------------------ */
          const tmp  = document.createElement('div');
          tmp.innerHTML = htmlTxt;
          const inner = tmp.querySelector('product-recommendations');
          if (inner && inner.innerHTML.trim()) this.innerHTML = inner.innerHTML;

          /* locate the fresh slider ------------------------------------------- */
          const slider = this.querySelector('.productlist-slider');
          if (!slider) return;

          this.classList.add('product-recommendations--loaded');
          const $slick = jQuery(slider);                 /* cached jQuery obj */

          /* --------------------------------------------------------------------
             A)  Theme-native initialisation (preferred)
             ------------------------------------------------------------------ */
          if (window.theme && typeof theme.initProductlist === 'function'){

            /* attach bar NOW; helper waits until Slick exists */
            attachProgressBar($slick);

            theme.initProductlist($slick);
            slider.style.opacity = '';
            return;
          }

          /* --------------------------------------------------------------------
             B)  Fallback: bare Slick initialisation
             ------------------------------------------------------------------ */
          if (window.jQuery && jQuery.fn.slick && !$slick.hasClass('slick-initialized')){

            /* attach bar BEFORE calling .slick(); helper will poll */
            attachProgressBar($slick);

            const opts = {
              slidesToShow   : Number(slider.dataset.slidesToShow) || 4,
              slidesToScroll : Number(slider.dataset.slidesToShow) || 4,
              rows           : Number(slider.dataset.rows)          || 1,
              arrows         : false,                               /* no overlay */
              dots           : slider.dataset.dots      === 'true',
              draggable      : slider.dataset.draggable === 'true',
              infinite       : slider.dataset.infinite  === 'true',
              responsive     : [{
                breakpoint : 768,
                settings   : {
                  slidesToShow   : Number(slider.dataset.slidestoshowMobile) || 2,
                  slidesToScroll : Number(slider.dataset.slidestoshowMobile) || 2,
                  rows           : 1
                }
              }]
            };

            $slick
              .on('init', ()=> slider.style.opacity = '')
              .slick(opts);
          }

          /* refresh review widgets if present --------------------------------- */
          if (window.SPR && theme && theme.review &&
              document.querySelector('.shopify-product-reviews-badge')) {
            window.SPR.registerCallbacks();
            window.SPR.initRatingHandler();
            window.SPR.initDomEls();
            window.SPR.loadProducts();
            window.SPR.loadBadges();
          }
        })
        .catch(console.error);
    };

    /* start lazy-load observer ----------------------------------------------- */
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin:'0px 0px 500px 0px'
    }).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
  var initPhotoSwipeFromDOM = function(gallerySelector) {

  // parse slide data (url, title, size ...) from DOM elements
  // (children of gallerySelector)
  var parseThumbnailElements = function(el) {
    var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
      numNodes = thumbElements.length,
      items = [],
      figureEl,
      linkEl,
      size,
      item;

    for (var i = 0; i < numNodes; i++) {

      figureEl = thumbElements[i]; // <figure> element
      // include only element nodes
      if (figureEl.nodeType !== 1) {
        continue;
      }

      linkEl = figureEl.children[0]; // <a> element
      if(linkEl.getAttribute('data-size')){
        size =  linkEl.getAttribute('data-size').split('x') ;
      }else{
        size =  [] ;
      }



      // create slide object
      item = {
        src: linkEl.getAttribute('href'),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10)
      };



      if (figureEl.children.length > 1) {
        // <figcaption> content
        item.title = figureEl.children[1].innerHTML;
      }

      if (linkEl.children.length > 0) {
        // thumbnail element, retrieving thumbnail url
        item.msrc = linkEl.children[0].getAttribute('src');
      }

      item.el = figureEl; // save link to element for getThumbBoundsFn
      items.push(item);
    }

    return items;
  };

  // find nearest parent element
  var closest = function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  };

  // triggers when user clicks on thumbnail
  var onThumbnailsClick = function(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;

    var eTarget = e.target || e.srcElement;

    // find root element of slide
    var clickedListItem = closest(eTarget, function(el) {
      return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
    });

    if (!clickedListItem) {
      return;
    }

    // find index of clicked item by looping through all child nodes
    // alternatively, you may define index via data- attribute
    var clickedGallery = clickedListItem.parentNode,
      childNodes = clickedListItem.parentNode.childNodes,
      numChildNodes = childNodes.length,
      nodeIndex = 0,
      index;

    for (var i = 0; i < numChildNodes; i++) {
      if (childNodes[i].nodeType !== 1) {
        continue;
      }

      if (childNodes[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }



    if (index >= 0) {
      // open PhotoSwipe if valid index found
      openPhotoSwipe(index, clickedGallery);
    }
    return false;
  };

  // parse picture index and gallery index from URL (#&pid=1&gid=2)
  var photoswipeParseHash = function() {
    var hash = window.location.hash.substring(1),
      params = {};

    if (hash.length < 5) {
      return params;
    }

    var vars = hash.split('&');
    for (var i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue;
      }
      var pair = vars[i].split('=');
      if (pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }

    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }

    return params;
  };

  var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
    var pswpElement = document.querySelectorAll('.pswp')[0],
      gallery,
      options,
      items;

    items = parseThumbnailElements(galleryElement);

    // define options (if needed)
    options = {
      maxSpreadZoom: 1,
      bgOpacity: 0.7,
      zoomEl: true,
      history: false,
      pinchToClose: false,
      closeOnScroll: false,

      // define gallery index (for URL)
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),

    };

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (var j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };

  // loop through all gallery elements and bind events
  var galleryElements = document.querySelectorAll(gallerySelector);

  for (var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute('data-pswp-uid', i + 1);
    galleryElements[i].onclick = onThumbnailsClick;
  }

  // Parse URL and open gallery if it contains #&pid=3&gid=1
  var hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }
  };

  // execute above function
  initPhotoSwipeFromDOM('.my-gallery');

  } catch(e) { console.error(e); }
})();
})();
